import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -14","key":"svg-0"}],["path",{"d":"M9 14a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M12 7l0 .01","key":"svg-2"}]]

const IconDeviceSpeaker = createReactComponent('outline', 'device-speaker', 'DeviceSpeaker', __iconNode);

export default IconDeviceSpeaker;